module.exports = __webpack_public_path__ + "img/diners.26dc6308.svg";